
import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink, useLocation } from 'react-router-dom'
import MaterialSymbol from '../icons/material-symbol'
import MyCampaigns from '../../assets/images/my-campaign.svg'
import MyCampaignsActive from '../../assets/images/my-campaign-active.svg'
import MyZap from '../../assets/images/zapIcon.svg'
import MyZapActive from '../../assets/images/zapIconActive.svg'
import MyProfile from '../../assets/images/profile.svg'
import MyProfileActive from '../../assets/images/profile-active.svg'
import { useIsUSInfluencer } from '../../hooks/useIsUSInfluencer'
import { INF_BASE, infPaths } from '../../modules/influencer/routes'
import { isTalentPartner, usesInfluencerFlow } from '../../modules/influencer/flowUser'

type Props = {}

const MobileFooter = (props: Props) => {
  const isUSInfluencer = useIsUSInfluencer();
  const { pathname } = useLocation();
  // Influencers, and Talent Partners inside a picked creator: Home and My
  // Campaigns are the new campaign flow's (modules/influencer).
  const user = useSelector((state: any) => state.UserReducer?.UserData)
  const owner = useSelector((state: any) => state.SwitchLayer2Reducer?.switchUser)
  const isInfluencer = usesInfluencerFlow(user, owner)
  const homePath = isInfluencer ? infPaths.home() : '/influencer/dashboard';
  // A Talent Partner with no creator picked picks one first (OLD: the old My
  // Campaigns page, which listed the retired legacy campaigns).
  const myCampaignsPath = isInfluencer ? infPaths.myCampaigns() : isTalentPartner(user) ? '/switch/user' : '/influencer/mycampaigns';
  // Branded Partnerships is opened from Home, so Home stays lit there.
  const onFeed = pathname === `${INF_BASE}/campaigns`;
  return (
  <section className='fixed-footer'>
    <div className='container'>

      {!isUSInfluencer && (
      <NavLink to={homePath} className={({ isActive }) => `fixed-footer-menu${isActive || onFeed ? ' active' : ''}`}>
        {({ isActive }) => (
          <>
            <MaterialSymbol
              iconName={isActive ? "home" : "home"}
                fontweight='200'
                iconFilled={isActive || onFeed}
            />
            <span className={isActive || onFeed ? "active-text" : ""}>Home</span>
          </>
        )}
      </NavLink>
      )}

      {!isUSInfluencer && (
      <NavLink to={myCampaignsPath} className="fixed-footer-menu">
        {({ isActive }) => (
          <>
            <img src={isActive ? MyCampaignsActive : MyCampaigns} />
            <span className={isActive ? "active-text" : ""}>My Campaigns</span>
          </>
        )}
      </NavLink>
      )}

      <NavLink to="/influencer/zap" className="fixed-footer-menu">
        {({ isActive }) => (
          <>
            <img src={isActive ? MyZapActive : MyZap} />
            <span className={isActive ? "active-text" : ""}>Zap</span>
          </>
        )}
      </NavLink>

      <NavLink to={isInfluencer ? infPaths.profile() : "/influencer/settings"} className="fixed-footer-menu">
        {({ isActive }) => (
          <>
            <img src={isActive ? MyProfileActive : MyProfile} />
            <span className={isActive ? "active-text" : ""}>Profile</span>
          </>
        )}
      </NavLink>

    </div>
  </section>
  )
}

export default MobileFooter